<template>
    <div>
        <!-- Trigger the Modal -->
        <img class="small-image" :src="imageSmall" @click="isOpen = true;" :style="{ width, height, objectFit: 'contain' }" />

        <!-- The Modal -->
        <div v-if="isOpen" id="myModal" class="modal">
            <!-- The Close Button -->
            <span class="close" @click="isOpen = false;">&times;</span> <img class="modal-content" id="img01" :src="imageBig" />
            <div id="caption" v-if="caption">{{ caption }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        imageSmall: {
            required: true,
            type: String
        },
        imageBig: {
            required: true,
            type: String
        },
        caption: {
            required: false,
            type: String
        },
        width: {
            type: String,
            required: false,
            default: "60px"
        },
        height: {
            type: String,
            required: false,
            default: "60px"
        }
    },
    data() {
        return {
            isOpen: false
        };
    },
    methods: {
        onClick() {
            this.$emit("close");
        }
    }
};
</script>

<style scoped lang="scss">
/* Style the Image Used to Trigger the Modal */
.small-image {
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
    position: relative;
}

.small-image:hover {
    opacity: 0.7;
}

/* The Modal (background) */
.modal {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 50; /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
}

/* Modal Content (Image) */
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 150px;
}

/* Add Animation - Zoom in the Modal */
.modal-content,
#caption {
    animation-name: zoom;
    animation-duration: 0.6s;
}

@keyframes zoom {
    from {
        transform: scale(0);
    }
    to {
        transform: scale(1);
    }
}

/* The Close Button */
.close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
}

.close:hover,
.close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
    .modal-content {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// ImageModal.vue?76142952